var lastScrollTop = 0;
//resize sizes
let w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;




(function () {

	document.addEventListener("DOMContentLoaded", function (event) {
		window.onload = onLoad();
	});

	// add burguer menu

	$('.header__burger').click(function () {
		$('.header').toggleClass('nav-open');
		if ($('.header').hasClass('widget-open')) {
			$('.header').removeClass('widget-open');
			$('.booking-block').removeClass('open');
			$('.header__book').text('Book Now');
		}
		if ($('.header').hasClass('open-book')) {
			$('.header').removeClass('open-book');
		}

		var text = $('.header__burger-label').text();
		$('.header__burger-label').text(
			text == "Menu" ? "Close" : "Menu");
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	// SWIPER
	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#header');
    const isMenuVisible = menu && menu.classList.contains('nav-open');
    const elements = document.querySelectorAll('#primary-nav a, #secondary-nav a, #third-nav a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();
    
    document.addEventListener('focusin', updateMenuTabIndex);

    const menu = document.querySelector('#header');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});



	const swiperClass = '.swiper-js';
	const swiperOps = {
		speed: 1000,
		loop: true,
		slidesPerView: 1,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,

		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		let combinedOps = Object.assign({}, swiperOps, dataOps);

		// if ('pagination' in combinedOps) {
		// 	combinedOps.pagination.renderBullet = swiperBullets;
		// }

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	// document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
	// 	const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
	// 	const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');


	// 	item.addEventListener('click', () => {
	// 		slider.swiper.slideTo(target);
	// 		item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
	// 		item.classList.add('js-swiper_active');
	// 	});
	// });

	// document.querySelectorAll('[data-swiper-prev]').forEach((item) => {
	// 	const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
	// 	item.addEventListener('click', () => slider.swiper.slidePrev());
	// });
	// document.querySelectorAll('[data-swiper-next]').forEach((item) => {
	// 	const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
	// 	item.addEventListener('click', () => slider.swiper.slideNext());
	// });

	document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
		const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
		if (selectorsLinked.length < 1) {
			return false;
		}

		const slidersLinked = selectorsLinked
			.map((selector) => {
				return [...document.querySelectorAll(selector)].map((el) => el.swiper);
			})
			.flat();
		mainSlider.swiper.controller.control = slidersLinked;
	});

	// function swiperBullets(index, className) {
	// 	return `<button class="${className}">
	// 		<span>${index + 1}</span>
	// 		<svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' xmlns='http: //www.w3.org/2000/svg'>
	// 			<circle cx='10' cy='10' r='9' fill='none' stroke='currentColor' stroke-width='1' pathLength="1" />
	// 			<circle cx='10' cy='10' r='2' />
	// 		</svg>
	// 	</button>`;
	// }

	let CloseMenu = document.querySelectorAll('.close-menu');

	if (CloseMenu[0]) {
		CloseMenu[0].addEventListener('click', function (e) {
			document.getElementById('navContainer').classList.remove('open');
			document.getElementById('mobileBurger').classList.remove('open');
		});
	}

	if (document.getElementById('mobileBurger')) {

		document.getElementById('mobileBurger').addEventListener('click', function () {
			document.getElementById('navContainer').classList.toggle('open')
			this.classList.toggle('open');
		})

	}

	// Main Nav Dropdown ----------------------------------------------------------------
	$("#primary-nav li").hover(function () {
		$(this).addClass("hover");
		$('ul.submenu', this).delay(200).fadeIn(100);
	}, function () {
		$(this).removeClass("hover");
		$('ul.submenu', this).delay(0).fadeOut(0);
	});

	$('ul.submenu').parent().addClass("sub-menu-li");

	//// Forms animation for labels
	//email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass: 'lbx-gallery',
		icons: {
			close: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><g data-name="Layer 1"><circle cx="16" cy="16" r="15" style="fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px"/><path d="m10.45 22.93-1.39-1.39 5.55-5.55-5.55-5.55 1.39-1.39L16 14.6l5.55-5.55 1.39 1.39-5.55 5.55 5.55 5.55-1.39 1.39L16 17.38l-5.55 5.55Z" style="fill:#fff"/></g></svg>',
			next: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="56" height="56"><defs><style>.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10}</style></defs><g data-name="Layer 1"><circle cx="28" cy="27.97" r="27.5" style="fill:#1c4a50"/><circle class="cls-3" cx="28" cy="28" r="27.5"/><path data-name="Line 20" class="cls-3" d="M40.66 27.97H10.54"/><path data-name="Polygon 1" d="m43.79 27.97-3.67 2.2v-4.4l3.67 2.2Z" style="fill:#fff"/></g></svg>',
			prev: '<svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="56" height="56"><defs><style>.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10}</style></defs><g data-name="Layer 1"><circle cx="28" cy="28.03" r="27.5" style="fill:#1c4a50"/><circle class="cls-3" cx="28" cy="28" r="27.5"/><path data-name="Line 20" class="cls-3" d="M15.34 28.03h30.12"/><path data-name="Polygon 1" d="m12.21 28.03 3.67-2.2v4.4l-3.67-2.2Z" style="fill:#fff"/></g></svg>'
		}


	});

	if (document.getElementById('navImages')) {

		let allMainLinks = document.getElementById('primary-nav').querySelectorAll('li')
		let allMainImages = document.getElementById('navImages').querySelectorAll('figure')

		allMainLinks.forEach((link, index) => {

			link.addEventListener('mouseenter', function () {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.add('active')
				}
			})
			link.addEventListener('mouseleave', function () {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.remove('active')
				}
			})

			let linkA = link.querySelectorAll('a')[0];
			if (linkA.classList.contains('active')) {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.add('active')
				}
			}

		});

	}


}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!header.classList.contains('down')) {
				header.classList.add('down');
				header.classList.remove('up');
			}
		} else {
			// upscroll code
			if (!header.classList.contains('up')) {
				header.classList.add('up');
				header.classList.remove('down');
			}
		}
	} else {
		if (header.classList.contains('up') || header.classList.contains('down')) {
			header.classList.remove('up');
			header.classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



function onLoad() {
	w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
		windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	convertBtn();

	//Check anchor on URL
	let anchorHref = window.location.href;
	if (anchorHref.indexOf('#') > 0) {
		if (anchorHref.split('#').length === 2) {
			let windowTarget = anchorHref.split('#')[1];
			if (document.getElementById(windowTarget)) {
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	window.addEventListener('scroll', function () {
		scrollW();
	})

}


function convertBtn() {
	setTimeout(() => {
		if (document.getElementsByClassName('btn').length > 0) {
			let ALL_BTNS = document.querySelectorAll('.btn');
			ALL_BTNS.forEach((btn) => {
				if (btn.getAttribute('type') !== 'submit') {
					let INNER_TEXT = btn.innerHTML;
					btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
				}
			});
		}
	}, "1500");
}



//vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

let rightGallery = new Swiper(".gallery-block__right", {
	speed: 700,
	loop: true,
	allowTouchMove: false,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		type: "fraction"

	}
});

